'use client';
import { EventBus } from '@s7/event-bus';

const EVENT_BUS = EventBus();

export { EVENT_BUS };
//# sourceMappingURL=bus.js.map
